export default __webpack_public_path__ + "static/Leaf3-875d63ac03c3fee6d6dcfc97d51a6329.png";